import { TrialInformationFetchService } from '../../application/TrialInformationFetchService';

const FAKE_LOADING_TIME_IN_MILLISECONDS = 300;

const STUDY_ID_FOR_NO_TRIAL_INFORMATION = 'no-trial-information';

export const buildFakeTrialInformationFetchService =
  (): TrialInformationFetchService.TrialInformationFetchService => {
    return {
      getTrialInformationForTrialExperience: async (studyId: string | null) => {
        if (!studyId || studyId === STUDY_ID_FOR_NO_TRIAL_INFORMATION) {
          return TrialInformationFetchService.emptyTrialInformationWithDiseaseAreas();
        }
        return new Promise(resolve =>
          setTimeout(
            () =>
              resolve({
                nctId: `NCT000${Math.round(Math.random() * 1000)}`,
                phase: 'Phase 3',
                sponsor: 'Novartis Pharmaceuticals',
                diseaseAreas: ['Secondary Progressive Multiple Sclerosis'],
                title:
                  'A Multicenter, Randomized, Double-blind, Parallel-group, Placebo-controlled Variable Treatment Duration Study Evaluating the Efficacy and Safety of Siponimod (BAF312) in Patients With Secondary Progressive Multiple Sclerosis Followed by Extended Treatment With Open-label BAF312.',
              }),
            FAKE_LOADING_TIME_IN_MILLISECONDS,
          ),
        );
      },
      getTrialInformationForExternalTrialCreation: async (
        studyId: string | null,
      ) => {
        if (!studyId || studyId === STUDY_ID_FOR_NO_TRIAL_INFORMATION) {
          return TrialInformationFetchService.emptyTrialInformationWithEligibilityCriteria();
        }

        return new Promise(resolve =>
          setTimeout(
            () =>
              resolve({
                nctId: `NCT000${Math.round(Math.random() * 1000)}`,
                sponsor: 'Novartis Pharmaceuticals',
                title:
                  'A Multicenter, Randomized, Double-blind, Parallel-group, Placebo-controlled Variable Treatment Duration Study Evaluating the Efficacy and Safety of Siponimod (BAF312) in Patients With Secondary Progressive Multiple Sclerosis Followed by Extended Treatment With Open-label BAF312.',
                inclusionCriteria:
                  '* diabetic retinopathy complicated by macular edema\n* Should be at least 18 years of age\n* Should be a female',
                exclusionCriteria:
                  '* congenital eye disorders,\n* previous diagnosis of other ocular diseases\n* history of vitreous hemorrhage',
              }),
            FAKE_LOADING_TIME_IN_MILLISECONDS,
          ),
        );
      },
    };
  };
